import { posthogCaptureWithUserContext } from "./general";
import {
  getSubskillPropertiesForEvent,
  getTaskAttemptPropertiesForEvent,
  getTaskPropertiesForEvent,
} from "./properties";

/**
 * Captures the event the user opens the video for a subskill.
 *
 * @param {Object} properties
 * @param {string} properties.triggerId The ID of the trigger.
 * @param {Parameters<typeof getSubskillPropertiesForEvent>[0]} properties.subskill The subskill object.
 * @param {Parameters<typeof getTaskPropertiesForEvent>[0] | undefined} properties.task Any associated task object.
 * @param {Parameters<typeof getTaskAttemptPropertiesForEvent>[0] | undefined} properties.attempt Any associated task attempt object.
 */
export function posthogEventSubskillVideoOpened({
  triggerId,
  subskill = {},
  task,
  attempt,
}) {
  let taskProperties = {};
  let attemptProperties = {};
  if (task && attempt) {
    taskProperties = getTaskPropertiesForEvent(task);
    attemptProperties = getTaskAttemptPropertiesForEvent(
      attempt,
      taskProperties.task_number_of_questions,
    );
  }
  posthogCaptureWithUserContext("subskill_video_opened", {
    trigger_id: triggerId,
    ...getSubskillPropertiesForEvent(subskill),
    ...taskProperties,
    ...attemptProperties,
  });
}

/**
 * Captures the event the user closes the video for a subskill.
 *
 * @param {Object} properties
 * @param {string} properties.triggerId The ID of the trigger.
 * @param {Parameters<typeof getSubskillPropertiesForEvent>[0]} properties.subskill The subskill object.
 * @param {Parameters<typeof getTaskPropertiesForEvent>[0] | undefined} properties.task Any associated task object
 * @param {Parameters<typeof getTaskAttemptPropertiesForEvent>[0] | undefined} properties.attempt Any associated task attempt object.
 * @param {Object} properties.videoStats
 * @param {number} properties.videoStats.duration The duration of the video in seconds.
 * @param {number} properties.videoStats.currentTime The current time of the video in seconds.
 */
export function posthogEventSubskillVideoClosed({
  triggerId,
  subskill = {},
  task,
  attempt,
  videoStats = {},
}) {
  let taskProperties = {};
  let attemptProperties = {};
  if (task && attempt) {
    taskProperties = getTaskPropertiesForEvent(task);
    attemptProperties = getTaskAttemptPropertiesForEvent(
      attempt,
      taskProperties.task_number_of_questions,
    );
  }
  const { currentTime = 0, duration = 0 } = videoStats;
  const watchedProportion =
    duration > 0 ? Number((currentTime / duration).toFixed(1)) : undefined;
  posthogCaptureWithUserContext("subskill_video_closed", {
    trigger_id: triggerId,
    ...getSubskillPropertiesForEvent(subskill),
    ...taskProperties,
    ...attemptProperties,
    subskill_video_watched_proportion: watchedProportion,
  });
}
